import format from 'string-format'
import {ModelBase} from './base'

function shiftColor(col, amt) {
	let usePound = false
	if (col[0] === "#") {
		col = col.slice(1)
		usePound = true
	}
	let num = parseInt(col, 16)
	let r = (num >> 16) + amt
	if (r > 255) {
		r = 255
	} else if (r < 0) {
		r = 0
	}

	let g = ((num >> 8) & 0x00FF) + amt
	if (g > 255) {
		g = 255
	} else if (g < 0) {
		g = 0
	}

	let b = (num & 0x0000FF) + amt
	if (b > 255) {
		b = 255
	} else if (b < 0) {
		b = 0
	}

	const res = (usePound ? "#" : "") + ((r << 16) | (g << 8) | b).toString(16)
	return res
}


class Probe extends ModelBase {

	constructor(data, rootState) {

		super(data)

		this._color = data.color

		this.dye = rootState.lists.dyes[data.dye_id]

		let k = 9
	}

	get color() {
		return this._color != null
			? this._color
			: this.dye.color != null
				? this.dye.color
				: 'gray'
	}

	get color_bg() {
		return shiftColor(this.color, +40)
	}

	static compare_probes_by_dye_order(p1, p2) {
		try {
			return p1.dye.order - p2.dye.order
		} catch {
			console.error(format(
				"Probe.compare_probes_by_dye_order( p1={0}, p2={1})",
				JSON.stringify(p1), JSON.stringify(p2)))
			return 0
		}
	}
}

export {Probe}